<!-- signup.component.html -->
<div class="flex flex-col md:flex-row w-full min-h-0">
  <!-- Mobile info banner -->
  <div
    class="md:hidden px-4 py-4 sm:px-6 sm:py-5 bg-sky-50 text-blue-950 sm:mx-4 sm:mt-3 sm:rounded-lg"
  >
    <ng-container *ngIf="registerStep === 'personal'">
      <h2 class="text-xl sm:text-2xl font-bold leading-tight">Looks like you are new here</h2>
      <p class="mt-2 text-sm font-medium leading-5 opacity-60">
        Register now by sharing a few details about yourself and get access to the best deals.
      </p>
    </ng-container>
    <ng-container *ngIf="registerStep === 'business'">
      <h2 class="text-xl sm:text-2xl font-bold leading-tight">Verify your business</h2>
      <p class="mt-2 text-sm font-medium leading-5 opacity-60">
        Add your PAN to unlock GST billing and faster checkout on ReWiRe.
      </p>
    </ng-container>
  </div>

  <!-- Left side - Info panel (desktop & tablet) -->
  <div
    class="hidden md:flex md:w-1/2 h-auto mx-4 my-3 pr-2 bg-sky-50 rounded-lg shrink-0"
  >
    <section
      class="overflow-hidden px-4 pt-8 pb-4 bg-sky-50 rounded-lg w-full max-w-[405px] text-blue-950"
    >
      <div class="flex flex-col justify-between min-h-[420px] xl:min-h-[470px]">
        <header class="w-full">
          <ng-container *ngIf="registerStep === 'personal'">
            <h2 class="text-2xl font-bold leading-none">
              Looks like you are new here
            </h2>
            <p class="mt-3 text-sm font-medium leading-5 opacity-60">
              Register now by sharing a few details about yourself and get access
              to the best deals on second hand parts and scrap materials.
            </p>
          </ng-container>
          <ng-container *ngIf="registerStep === 'business'">
            <h2 class="text-2xl font-bold leading-none">Verify your business</h2>
            <p class="mt-3 text-sm font-medium leading-5 opacity-60">
              Add your PAN to unlock GST billing and faster checkout on ReWiRe.
            </p>
          </ng-container>
        </header>

        <svg
          *ngIf="registerStep === 'personal'"
          id="1:11567"
          width="265"
          height="198"
          viewBox="0 0 140 198"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="registration-illustration hidden xl:block mt-6"
          style="width: 230px; height: 198px"
        >
          <path
            d="M11.2188 188H26.4353"
            stroke="#0A0A5F"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
          <path
            d="M32.0391 188H155.373"
            stroke="#0A0A5F"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
          <path
            d="M162 188H254"
            stroke="#0A0A5F"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
          <path
            d="M192.706 75.49L173.626 79.6376L153.047 146.924"
            stroke="#0A0A5F"
            stroke-width="4"
            stroke-linecap="round"
          ></path>
          <path
            opacity="0.5"
            d="M65.3141 94.7222C64.9573 93.4523 65.906 92.1908 67.2251 92.1813L163.732 91.4848C165.089 91.475 166.061 92.7894 165.655 94.0835L149.146 146.703C148.884 147.538 148.11 148.105 147.235 148.104L81.8089 148.042C80.9134 148.041 80.1277 147.445 79.8854 146.583L65.3141 94.7222Z"
            fill="#0A0A5F"
          ></path>
          <path
            d="M81.6937 151.286L154.392 151.435C159.142 151.444 162.936 155.392 162.758 160.139V160.139C162.588 164.643 158.891 168.208 154.384 168.213L60.9349 168.325"
            stroke="#0A0A5F"
            stroke-width="4"
            stroke-linecap="round"
          ></path>
          <circle
            cx="84.0781"
            cy="179.135"
            r="5"
            stroke="#0A0A5F"
            stroke-width="4"
          ></circle>
          <circle
            cx="139.859"
            cy="179"
            r="5"
            stroke="#0A0A5F"
            stroke-width="4"
          ></circle>
          <circle
            opacity="0.5"
            cx="139.859"
            cy="179.004"
            r="3"
            fill="#0A0A5F"
          ></circle>
          <circle
            opacity="0.5"
            cx="84.0801"
            cy="179.136"
            r="3"
            fill="#0A0A5F"
          ></circle>
          <path
            d="M65.6523 122.672L71.7845 145.242"
            stroke="#0A0A5F"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
          <path
            d="M168 135H207"
            stroke="#0A0A5F"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
          <path
            d="M174 119H213"
            stroke="#0A0A5F"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
          <path
            d="M182 103H221"
            stroke="#0A0A5F"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
          <path
            d="M56.5176 112.014L60.1882 125.524"
            stroke="#0A0A5F"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
          <path
            d="M61.2539 129.444L63.4093 137.377"
            stroke="#0A0A5F"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M113.29 107.714L109.859 113.791L113.569 115.951L116.753 110.353L119.978 115.931L117.928 117.142L124.07 118.776L124.081 118.778L125.721 112.534L123.671 113.747L120.306 107.873C118.747 105.148 114.931 105.091 113.29 107.714ZM102.148 128.718C102.145 127.885 102.294 127.217 102.706 126.485L106.031 120.586L103.976 119.39L104.59 119.225L104.59 119.222L110.116 117.711L111.799 123.948L109.742 122.746L106.599 128.376L112.963 128.379L112.975 132.725L106.29 132.746C103.975 132.753 102.23 130.871 102.148 128.718L102.148 128.718ZM127.371 132.672C130.541 132.661 132.514 129.184 130.912 126.388L127.549 120.514L123.853 122.7L127.033 128.304L120.666 128.352L120.661 125.942L116.189 130.537L120.69 135.107L120.681 132.695L127.371 132.672Z"
            fill="#0A0A5F"
          ></path>
        </svg>
        <!-- <img
              src="/assets/images/registration-illustration.png"
              class="object-contain self-center mt-36 max-w-full aspect-[1.34] w-[265px]"
              alt="Registration illustration"
            /> -->
      </div>
    </section>
  </div>

  <!-- Right side - Form -->
  <div class="w-full md:w-1/2 flex-1 min-w-0 px-4 sm:px-6 py-4 md:py-5 lg:py-3">
    <div class="flex flex-col grow w-full max-w-full">
      <section class="flex relative flex-col w-full max-w-[480px] lg:max-w-[445px] mx-auto lg:mx-0">
        <button
          (click)="onClose()"
          class="hidden md:block self-end mr-5 p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 max-md:mr-2.5"
          aria-label="Close modal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div class="flex flex-col gap-4 sm:gap-5 items-start w-full">
          <!-- Personal Details Step -->
          <ng-container *ngIf="registerStep === 'personal'">
          <h1 class="text-2xl font-bold leading-8 text-black">
            Personal Details
          </h1>
          <p class="text-sm sm:text-base font-medium leading-5 text-black opacity-60">
            It'll be over in no more than 30 seconds.
          </p>

          <div class="flex flex-col gap-4 items-start w-full">
            <div class="flex flex-col gap-2 items-start w-full">
              <div class="flex flex-col md:flex-row gap-2 w-full">
                <!-- First Name -->
                <div class="flex flex-col flex-1 gap-1 w-full">
                  <label class="text-xs sm:text-sm font-bold text-zinc-700">
                    First Name
                  </label>
                  <input
                    type="text"
                    [(ngModel)]="personalDetails.firstName"
                    (input)="validateNameInput($event, 'firstName')"
                    (blur)="onFirstNameBlur()"
                    (keyup.enter)="onSubmit()"
                    placeholder="Enter your first name"
                    class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200"
                    [class.border-red-500]="getFirstNameError()"
                    [class.border-neutral-300]="!getFirstNameError()"
                    [class.focus:ring-red-500]="getFirstNameError()"
                    [class.focus:ring-blue-350]="!getFirstNameError()"
                    [class.focus:border-red-500]="getFirstNameError()"
                    [class.focus:border-blue-350]="!getFirstNameError()"
                    focus:outline-none
                    focus:ring-2
                    autofocus
                  />
                  <div
                    *ngIf="getFirstNameError()"
                    class="text-red-500 text-xs mt-1"
                  >
                    {{ getFirstNameError() }}
                  </div>
                </div>

                <!-- Last Name -->
                <div class="flex flex-col flex-1 gap-1 w-full">
                  <label class="text-xs sm:text-sm font-bold text-zinc-700">
                    Last Name
                  </label>
                  <input
                    type="text"
                    [(ngModel)]="personalDetails.lastName"
                    (input)="validateNameInput($event, 'lastName')"
                    (blur)="onLastNameBlur()"
                    (keyup.enter)="onSubmit()"
                    placeholder="Enter your last name"
                    class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200"
                    [class.border-red-500]="getLastNameError()"
                    [class.border-neutral-300]="!getLastNameError()"
                    [class.focus:ring-red-500]="getLastNameError()"
                    [class.focus:ring-blue-350]="!getLastNameError()"
                    [class.focus:border-red-500]="getLastNameError()"
                    [class.focus:border-blue-350]="!getLastNameError()"
                    focus:outline-none
                    focus:ring-2
                  />
                  <div
                    *ngIf="getLastNameError()"
                    class="text-red-500 text-xs mt-1"
                  >
                    {{ getLastNameError() }}
                  </div>
                </div>
              </div>

              <!-- Email -->
              <div class="flex flex-col gap-1 w-full">
                <label
                  class="flex justify-between text-xs sm:text-sm font-bold text-zinc-700"
                >
                  Email Id
                  <span class="text-gray-500 font-normal">(Optional)</span>
                </label>

                <input
                  type="email"
                  [(ngModel)]="personalDetails.email"
                  (blur)="onEmailBlur()"
                  (keyup.enter)="onSubmit()"
                  placeholder="Enter email id"
                  class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200"
                  [class.border-red-500]="getEmailError()"
                  [class.border-neutral-300]="!getEmailError()"
                  [class.focus:ring-red-500]="getEmailError()"
                  [class.focus:ring-blue-350]="!getEmailError()"
                  [class.focus:border-red-500]="getEmailError()"
                  [class.focus:border-blue-350]="!getEmailError()"
                  focus:outline-none
                  focus:ring-2
                />
                <div *ngIf="getEmailError()" class="text-red-500 text-xs mt-1">
                  {{ getEmailError() }}
                </div>
              </div>
            </div>

            <!-- User Type Selection -->
            <div class="flex flex-col gap-3 items-start w-full">
              <h2 class="text-base font-bold leading-4 text-zinc-700">
                Who are you?
              </h2>
              <p class="text-xs font-medium leading-2 text-neutral-500">
                You can select only one option at a time
              </p>

              <div
                class="flex flex-wrap gap-2 content-start items-start w-full"
              >
                <ng-container *ngFor="let type of userTypes">
                  <button
                    type="button"
                    (click)="onUserTypeSelect(type)"
                    class="gap-2 px-2 py-1 text-sm font-medium leading-5 rounded border border-solid transition-colors"
                    [class.bg-blue-50]="type.selected"
                    [class.text-blue-500]="type.selected"
                    [class.border-blue-500]="type.selected"
                    [class.text-black]="!type.selected"
                    [class.border-neutral-300]="!type.selected"
                  >
                    {{ type.label }}
                  </button>
                </ng-container>
              </div>
              <div *ngIf="getUserTypeError()" class="text-red-500 text-xs mt-1">
                {{ getUserTypeError() }}
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="flex justify-end mt-8 sm:mt-12 lg:mt-16 w-full">
            <button
              type="button"
              (click)="onSubmit()"
              class="p-2.5 sm:p-2 text-base font-bold leading-6 text-white rounded-lg bg-blue-950 w-full sm:w-[200px]"
              [class.opacity-60]="!isFormValid() || loading"
              [disabled]="!isFormValid() || loading"
            >
              <span class="gap-2 self-stretch my-auto">
                <ng-container *ngIf="!loading">Create Account</ng-container>
                <ng-container *ngIf="loading">Creating...</ng-container>
              </span>
            </button>
          </div>
          </ng-container>

          <!-- Business Details Step -->
          <ng-container *ngIf="registerStep === 'business'">
            <h1 class="text-2xl font-bold leading-8 text-black">Business Details</h1>
            <p class="text-sm sm:text-base font-medium leading-5 text-black opacity-60">
              Enter your PAN to fetch linked GSTINs for this account.
            </p>

            <div class="flex flex-col gap-4 items-start w-full">
              <div class="flex flex-col gap-1 w-full">
                <label class="text-xs sm:text-sm font-bold text-zinc-700">Full Name (as on PAN)</label>
                <input
                  type="text"
                  [(ngModel)]="businessFullName"
                  (blur)="onFullNameBlur()"
                  (keyup.enter)="onSubmit()"
                  placeholder="Enter name as on PAN card"
                  class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200"
                  [class.border-red-500]="getFullNameError()"
                  [class.border-neutral-300]="!getFullNameError()"
                  autofocus
                />
                <div *ngIf="getFullNameError()" class="text-red-500 text-xs mt-1">
                  {{ getFullNameError() }}
                </div>
              </div>
              <div class="flex flex-col gap-1 w-full">
                <label class="text-xs sm:text-sm font-bold text-zinc-700">PAN Number</label>
                <input
                  type="text"
                  [(ngModel)]="panNumber"
                  (input)="onPanInput($event)"
                  (blur)="onPanBlur()"
                  (keyup.enter)="onSubmit()"
                  placeholder="ABCDE1234F"
                  maxlength="10"
                  class="p-2 w-full h-10 text-base font-medium text-black rounded-lg border transition-all duration-200 uppercase"
                  [class.border-red-500]="getPanError()"
                  [class.border-neutral-300]="!getPanError()"
                />
                <div *ngIf="getPanError()" class="text-red-500 text-xs mt-1">{{ getPanError() }}</div>
              </div>
            </div>

            <div
              class="flex flex-col-reverse sm:flex-row gap-3 sm:gap-0 mt-8 sm:mt-12 lg:mt-16 w-full items-stretch sm:items-center"
              [class.sm:justify-between]="!checkoutMode"
              [class.sm:justify-end]="checkoutMode"
            >
              <button
                *ngIf="!checkoutMode"
                type="button"
                (click)="onSkipBusiness()"
                class="text-sm font-medium text-blue-500 hover:underline text-center sm:text-left py-1"
              >
                Skip for now
              </button>
              <button
                type="button"
                (click)="onSubmit()"
                class="p-2.5 sm:p-2 text-base font-bold leading-6 text-white rounded-lg bg-blue-950 w-full sm:w-[200px]"
                [class.opacity-60]="!isBusinessValid() || loading"
                [disabled]="!isBusinessValid() || loading"
              >
                <span class="gap-2 self-stretch my-auto">
                  <ng-container *ngIf="!loading">{{ businessLoadingLabel }}</ng-container>
                  <ng-container *ngIf="loading">{{ businessLoadingLabel }}</ng-container>
                </span>
              </button>
            </div>
          </ng-container>

          <!-- Error Message -->
          <div
            *ngIf="errorMessage"
            class="text-red-500 text-sm mt-3 mb-2 text-center w-full max-sm:mt-4 max-sm:mb-4 max-sm:px-2 max-sm:text-xs max-sm:block"
          >
            {{ errorMessage }}
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
